import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { MsalGuard } from '@azure/msal-angular';
import { MonthPerformanceComponent } from './month-performance/month-performance.component';
import { YearPerformanceComponent } from './year-performance/year-performance.component';
import { CoachingComponent } from './coaching/coaching.component';
import { ScoreCardComponent } from './score-card/score-card.component';
import { AchievementComponent } from './achievement/achievement.component';
import { EconomyKpiComponent } from './economy-kpi/economy-kpi.component';
import { MilestoneComponent } from './milestone/milestone.component';
import { TestVjsPlayerComponent } from './test-vjs-player/test-vjs-player.component';
import { TeamMessageComponent } from './team-message/team-message.component';
import { TeamMessageDetailComponent } from './team-message-detail/team-message-detail.component';
import { SetApexIdComponent } from './set-apex-id/set-apex-id.component';
import { LearnexComponent } from './learnex/learnex.component';

export const routes: Routes = [
    // { path: '', redirectTo: '/home', pathMatch: 'full' },
    // { path: '', component: HomeComponent, canActivate: [ MsalGuard ] },
    { path: '', component: HomeComponent, canActivate: [ MsalGuard ] },
    { path: 'month-performance', component: MonthPerformanceComponent, canActivate: [ MsalGuard ] },
    { path: 'year-performance', component: YearPerformanceComponent, canActivate: [ MsalGuard ] },
    { path: 'score', component: ScoreCardComponent, canActivate: [ MsalGuard ] },
    { path: 'achievement', component: AchievementComponent, canActivate: [ MsalGuard ] },
    { path: 'economy-kpi', component: EconomyKpiComponent, canActivate: [ MsalGuard ] },
    { path: 'milestone', component: MilestoneComponent, canActivate: [ MsalGuard ] },
    { path: 'test-vjs-player', component: TestVjsPlayerComponent },
    { path: 'coaching', component: CoachingComponent, canActivate: [ MsalGuard ] },
    { path: 'team-message', component: TeamMessageComponent, canActivate: [ MsalGuard ] },
    { path: 'team-message-detail', component: TeamMessageDetailComponent, canActivate: [ MsalGuard ] },
    { path: 'learnex', component: LearnexComponent, canActivate: [ MsalGuard ] },
    // { path: '', redirectTo: '/home', pathMatch: 'full' },
    // { path: 'home', component: HomeComponent, canActivate: [ MsalGuard ] },
    { path: 'set-apex-id', component: SetApexIdComponent },
];
